module.exports = __webpack_public_path__ + "img/slide2.f05920fe.png";